import ServicesCategoryPage from './ServicesCategoryPage';

export default ServicesCategoryPage;
